import DCFDatepicker from '@dcf/js/components/dcf-datepicker.js';

export default class UNLDatepicker extends DCFDatepicker {
    constructor(datepicker, options = {}) {
        super(datepicker, options);
    }
}
